"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCitizenConsentForm = exports.setCitizenConsertFormData = exports.resetFetchRecords = exports.fetchRemRecords = exports.fetchRecords = exports.fetchInboxRecordsCount = exports.getNotifications = exports.setNotificationsComplete = exports.getNotificationCount = exports.setNotificationCount = exports.fetchUiCommonConstants = exports.fetchUiCommonConfig = exports.setUiCommonConstants = exports.setUiCommonConfig = exports.fetchActionItems = exports.fetchCurrentLocation = exports.fetchExpenditureDetails = exports.fetchPurchaseOrderDetails = exports.fetchDepartmentReceiptDetails = exports.fetchReceiptsDetails = exports.fetchTotalGrant = exports.fetchWorkOrderByStatus = exports.fetchWorkOrderByCategory = exports.fetchRevenueTrendDetails = exports.fetchZoneDetails = exports.fetchSupplierDetails = exports.fetchOpeningBalanceDetails = exports.fetchContractorDetails = exports.fetchFilter = exports.fetchDashboardSummaryWithoutFilter = exports.fetchWorkOrderDetails = exports.fetchWorkOrderFundDetails = exports.fetchPurchaseOrderFundDetails = exports.fetchSchemeDetailGrant = exports.fetchExpenditureFundDetails = exports.fetchFinancialYears = exports.setWorkOrderByStatus = exports.setPurchaseOrderDetails = exports.setWorkOrderByCategory = exports.setRevenueTrend = exports.setZoneDetails = exports.setPurchaseOrderFundDetails = exports.setExpenditureDetails = exports.setDepartmentReceiptDetails = exports.setReceiptsDetails = exports.setTotalGrant = exports.setSupplierDetails = exports.setOpeningBalanceDetails = exports.setContractorDetails = exports.setFilterApi = exports.setDashboardSummaryFilter = exports.setWorkOrderDetails = exports.setWorkOrderFundDetails = exports.setSchemeDetailGrant = exports.setExpenditureFundDetails = exports.setFinancialYears = exports.showTable = exports.showLoader = exports.showSnackbar = exports.addBreadCrumbs = exports.fetchLocalizationLabelForOpenScreens = exports.fetchLocalizationLabel = exports.toggleSnackbarAndSetText = exports.setLocalizationLabels = exports.setBottomNavigationIndex = exports.setPreviousRoute = exports.setRoute = exports.updateActiveRoute = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _common = require("config/common");

var _common2 = _interopRequireDefault(_common);

var _api = require("egov-ui-kit/utils/api");

var _commons = require("egov-ui-kit/utils/commons");

var _endPoints = require("egov-ui-kit/utils/endPoints");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _util = require("util");

var _endPoints2 = require("../../utils/endPoints");

var _localStorageUtils2 = require("../../utils/localStorageUtils");

var _actionTypes = require("./actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _actions = require("egov-ui-kit/redux/auth/actions");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateActiveRoute = exports.updateActiveRoute = function updateActiveRoute(routePath, menuName) {
  (0, _localStorageUtils.localStorageSet)("menuPath", routePath);
  (0, _localStorageUtils.localStorageSet)("menuName", menuName);
  return { type: actionTypes.UPDATE_ACTIVE_ROUTE_PATH, routePath: routePath };
};

var setRoute = exports.setRoute = function setRoute(route) {
  return { type: actionTypes.SET_ROUTE, route: route };
};

var setPreviousRoute = exports.setPreviousRoute = function setPreviousRoute(route) {
  return { type: actionTypes.SET_PREVIOUS_ROUTE, route: route };
};

var setBottomNavigationIndex = exports.setBottomNavigationIndex = function setBottomNavigationIndex(bottomNavigationIndex) {
  return { type: actionTypes.CHANGE_BOTTOM_NAVIGATION_INDEX, bottomNavigationIndex: bottomNavigationIndex };
};

var setLocalizationLabels = exports.setLocalizationLabels = function setLocalizationLabels(locale, localizationLabels) {
  window.localStorage.setItem("localization_" + locale, JSON.stringify(localizationLabels));
  (0, _localStorageUtils.setLocale)(locale);
  return { type: actionTypes.ADD_LOCALIZATION, locale: locale, localizationLabels: localizationLabels };
};

var toggleSnackbarAndSetText = exports.toggleSnackbarAndSetText = function toggleSnackbarAndSetText(open) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var variant = arguments[2];

  return {
    type: actionTypes.SHOW_TOAST,
    open: open,
    message: message,
    variant: variant
  };
};

var fetchLocalizationLabel = exports.fetchLocalizationLabel = function fetchLocalizationLabel() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en_IN";
  var module = arguments[1];
  var tenantId = arguments[2];
  var isFromModule = arguments[3];

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      var storedModuleList, moduleName, localeModule, resultArray, tenantModule, isCommonScreen, payload1, newList, payload2, prevLocalisationLabels;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              storedModuleList = [];

              if ((0, _localStorageUtils2.getStoredModulesList)() !== null) {
                storedModuleList = JSON.parse((0, _localStorageUtils2.getStoredModulesList)());
              }
              moduleName = (0, _localStorageUtils2.getModule)();
              localeModule = void 0;

              if (moduleName === "rainmaker-common") {
                localeModule = "rainmaker-common";
              } else if (storedModuleList.includes("rainmaker-common")) {
                localeModule = moduleName;
              } else {
                localeModule = moduleName ? "rainmaker-common," + moduleName : "rainmaker-common";
              }
              _context.prev = 5;
              resultArray = [], tenantModule = "", isCommonScreen = void 0;

              if (module != null) {
                tenantModule = "rainmaker-" + module;
              }

              if (window.location.href.includes("/language-selection") || window.location.href.includes("/user/register") || window.location.href.includes("/user/login") || window.location.href.includes("/withoutAuth")) {
                if (moduleName && storedModuleList.includes(moduleName) === false || moduleName == null) isCommonScreen = true;
              }

              if (window.location.href.includes("/inbox")) {
                if (moduleName && storedModuleList.includes("rainmaker-common")) isFromModule = false;
              }

              if (!(moduleName && storedModuleList.includes(moduleName) === false || isFromModule || isCommonScreen)) {
                _context.next = 16;
                break;
              }

              _context.next = 13;
              return (0, _api.httpRequest)(_endPoints.LOCALATION.GET.URL, _endPoints.LOCALATION.GET.ACTION, [{ key: "module", value: localeModule }, { key: "locale", value: locale }, { key: "tenantId", value: _common2.default.tenantId }]);

            case 13:
              payload1 = _context.sent;

              console.log("payload1", payload1);
              resultArray = [].concat((0, _toConsumableArray3.default)(payload1.messages));

            case 16:
              if (!(module && storedModuleList.includes(tenantModule) === false)) {
                _context.next = 28;
                break;
              }

              storedModuleList.push(tenantModule);
              newList = JSON.stringify(storedModuleList);

              if (!module) {
                _context.next = 25;
                break;
              }

              _context.next = 22;
              return (0, _api.httpRequest)(_endPoints.LOCALATION.GET.URL, _endPoints.LOCALATION.GET.ACTION, [{ key: "module", value: "rainmaker-" + module }, { key: "locale", value: locale }, { key: "tenantId", value: tenantId ? tenantId : _common2.default.tenantId }]);

            case 22:
              _context.t0 = _context.sent;
              _context.next = 26;
              break;

            case 25:
              _context.t0 = [];

            case 26:
              payload2 = _context.t0;

              if (payload2 && payload2.messages) {
                (0, _localStorageUtils2.setStoredModulesList)(newList);
                resultArray = [].concat((0, _toConsumableArray3.default)(resultArray), (0, _toConsumableArray3.default)(payload2.messages));
              }

            case 28:
              prevLocalisationLabels = [];

              if ((0, _localStorageUtils2.getLocalizationLabels)() != null && !isCommonScreen && storedModuleList.length > 0) {
                prevLocalisationLabels = JSON.parse((0, _localStorageUtils2.getLocalizationLabels)());
              }
              resultArray = [].concat((0, _toConsumableArray3.default)(prevLocalisationLabels), (0, _toConsumableArray3.default)(resultArray));
              localStorage.removeItem("localization_" + (0, _localStorageUtils.getLocale)());
              dispatch(setLocalizationLabels(locale, resultArray));
              _context.next = 37;
              break;

            case 35:
              _context.prev = 35;
              _context.t1 = _context["catch"](5);

            case 37:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[5, 35]]);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

var fetchLocalizationLabelForOpenScreens = exports.fetchLocalizationLabelForOpenScreens = function fetchLocalizationLabelForOpenScreens() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "en_IN";
  var module = arguments[1];
  var tenantId = arguments[2];
  var isFromModule = arguments[3];

  return function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
      var storedModuleList, moduleName, localeModule, resultArray, tenantModule, isCommonScreen, payload2, prevLocalisationLabels;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              storedModuleList = [];

              if ((0, _localStorageUtils2.getStoredModulesList)() !== null) {
                storedModuleList = JSON.parse((0, _localStorageUtils2.getStoredModulesList)());
              }
              moduleName = (0, _localStorageUtils2.getModule)();
              localeModule = void 0;

              if (moduleName === "rainmaker-common") {
                localeModule = "rainmaker-common";
              } else if (storedModuleList.includes("rainmaker-common")) {
                localeModule = moduleName;
              } else {
                localeModule = moduleName ? "rainmaker-common," + moduleName : "rainmaker-common";
              }
              _context2.prev = 5;
              resultArray = [], tenantModule = "", isCommonScreen = void 0;

              if (module != null) {
                tenantModule = "rainmaker-" + module;
              }

              if (!(module && storedModuleList.includes(tenantModule) === false)) {
                _context2.next = 19;
                break;
              }

              storedModuleList.push(tenantModule);

              if (!module) {
                _context2.next = 16;
                break;
              }

              _context2.next = 13;
              return (0, _api.httpRequest)(_endPoints.LOCALATION.GET.URL, _endPoints.LOCALATION.GET.ACTION, [{ key: "module", value: "rainmaker-" + module }, { key: "locale", value: locale }, { key: "tenantId", value: tenantId ? tenantId : _common2.default.tenantId }]);

            case 13:
              _context2.t0 = _context2.sent;
              _context2.next = 17;
              break;

            case 16:
              _context2.t0 = [];

            case 17:
              payload2 = _context2.t0;

              if (payload2 && payload2.messages) {
                resultArray = [].concat((0, _toConsumableArray3.default)(resultArray), (0, _toConsumableArray3.default)(payload2.messages));
              }

            case 19:
              prevLocalisationLabels = [];

              if ((0, _localStorageUtils2.getLocalizationLabels)() != null && !isCommonScreen && storedModuleList.length > 0) {
                prevLocalisationLabels = JSON.parse((0, _localStorageUtils2.getLocalizationLabels)());
              }
              resultArray = [].concat((0, _toConsumableArray3.default)(prevLocalisationLabels), (0, _toConsumableArray3.default)(resultArray));
              localStorage.removeItem("localization_" + (0, _localStorageUtils.getLocale)());
              dispatch(setLocalizationLabels(locale, resultArray));
              _context2.next = 28;
              break;

            case 26:
              _context2.prev = 26;
              _context2.t1 = _context2["catch"](5);

            case 28:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[5, 26]]);
    }));

    return function (_x5) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var setActionItems = function setActionItems(payload) {
  return {
    type: actionTypes.FETCH_ACTIONMENU,
    payload: payload
  };
};

var fetchInboxCount = function fetchInboxCount(payload) {
  return {
    type: actionTypes.FETCH_INBOX_COUNT,
    payload: payload
  };
};
var fetchInboxRecords = function fetchInboxRecords(payload) {
  return {
    type: actionTypes.FETCH_INBOX_RECORDS,
    payload: payload
  };
};
var fetchInboxRecordsError = function fetchInboxRecordsError(payload) {
  return {
    type: actionTypes.FETCH_INBOX_RECORDS_ERROR,
    payload: payload
  };
};
var fetchInboxRecordsPending = function fetchInboxRecordsPending() {
  return {
    type: actionTypes.FETCH_INBOX_RECORDS_PENDING
  };
};
var fetchRemInboxRecords = function fetchRemInboxRecords(payload) {
  return {
    type: actionTypes.FETCH_REM_INBOX_RECORDS_COMPLETE,
    payload: payload
  };
};
var fetchResetInboxRecords = function fetchResetInboxRecords() {
  return {
    type: actionTypes.FETCH_RESET_INBOX_RECORDS
  };
};

var fetchRemInboxRecordsError = function fetchRemInboxRecordsError(payload) {
  return {
    type: actionTypes.FETCH_REM_INBOX_RECORDS_ERROR,
    payload: payload
  };
};
var fetchRemInboxRecordsPending = function fetchRemInboxRecordsPending() {
  return {
    type: actionTypes.FETCH_REM_INBOX_RECORDS_PENDING
  };
};
var fetchActionItemsError = function fetchActionItemsError(payload) {
  return {
    type: actionTypes.FETCH_ACTIONMENU_ERROR,
    payload: payload
  };
};
var fetchActionItemsPending = function fetchActionItemsPending() {
  return {
    type: actionTypes.FETCH_ACTIONMENU_PENDING
  };
};

var setCurrentLocation = function setCurrentLocation(currentLocation) {
  return {
    type: actionTypes.SET_USER_CURRENT_LOCATION,
    currentLocation: currentLocation
  };
};

var addBreadCrumbs = exports.addBreadCrumbs = function addBreadCrumbs(url) {
  return { type: actionTypes.ADD_BREADCRUMB_ITEM, url: url };
};
var showSnackbar = exports.showSnackbar = function showSnackbar(message) {
  return {
    type: "SHOW_SNACKBAR",
    payload: message
  };
};

var showLoader = exports.showLoader = function showLoader(message) {
  return {
    type: "SHOW_LOADER",
    payload: message
  };
};

var showTable = exports.showTable = function showTable(message) {
  return {
    type: "SHOW_TABLE",
    payload: message
  };
};

var setFinancialYears = exports.setFinancialYears = function setFinancialYears(payload) {
  return {
    type: "FETCH_FINANCIAL_YEARS",
    payload: payload
  };
};
var setExpenditureFundDetails = exports.setExpenditureFundDetails = function setExpenditureFundDetails(payload) {
  return {
    type: "FETCH_EXPENDITURE_FUND_DETAILS",
    payload: payload
  };
};
var setSchemeDetailGrant = exports.setSchemeDetailGrant = function setSchemeDetailGrant(payload) {
  return {
    type: "FETCH_SCHEME_DETAIL_GRANT",
    payload: payload
  };
};
var setWorkOrderFundDetails = exports.setWorkOrderFundDetails = function setWorkOrderFundDetails(payload) {
  return {
    type: "FETCH_WORKORDER_FUND_DETAILS",
    payload: payload
  };
};

var setWorkOrderDetails = exports.setWorkOrderDetails = function setWorkOrderDetails(payload) {
  return {
    type: "FETCH_WORKORDER_DETAILS",
    payload: payload
  };
};

var setDashboardSummaryFilter = exports.setDashboardSummaryFilter = function setDashboardSummaryFilter(payload) {
  return {
    type: "FETCH_DASHBOARD_FILTERS_DETAILS",
    payload: payload
  };
};
var setFilterApi = exports.setFilterApi = function setFilterApi(payload) {
  return {
    type: "FETCH_FILTER_API",
    payload: payload
  };
};
var setContractorDetails = exports.setContractorDetails = function setContractorDetails(payload) {
  return {
    type: "FETCH_CONTRACTOR_DETAILS",
    payload: payload
  };
};
var setOpeningBalanceDetails = exports.setOpeningBalanceDetails = function setOpeningBalanceDetails(payload) {
  return {
    type: "FETCH_OPENING_BALANCE_DETAILS",
    payload: payload
  };
};
var setSupplierDetails = exports.setSupplierDetails = function setSupplierDetails(payload) {
  return {
    type: "FETCH_SUPPLIER_DETAILS",
    payload: payload
  };
};

var setTotalGrant = exports.setTotalGrant = function setTotalGrant(payload) {
  return {
    type: "FETCH_TOTAL_GRANT",
    payload: payload
  };
};

var setReceiptsDetails = exports.setReceiptsDetails = function setReceiptsDetails(payload) {
  return {
    type: "FETCH_RECEIPT_DETAILS",
    payload: payload
  };
};

var setDepartmentReceiptDetails = exports.setDepartmentReceiptDetails = function setDepartmentReceiptDetails(payload) {
  return {
    type: "FETCH_DEPARTMENT_RECEIPT_DETAILS",
    payload: payload
  };
};

var setExpenditureDetails = exports.setExpenditureDetails = function setExpenditureDetails(payload) {
  return {
    type: "FETCH_EXPENDITURE_DETAILS",
    payload: payload
  };
};

var setPurchaseOrderFundDetails = exports.setPurchaseOrderFundDetails = function setPurchaseOrderFundDetails(payload) {
  return {
    type: "FETCH_PURCHASE_ORDER_FUND_DETAILS",
    payload: payload
  };
};

var setZoneDetails = exports.setZoneDetails = function setZoneDetails(payload) {
  return {
    type: "FETCH_ZONE_DETAILS",
    payload: payload
  };
};

var setRevenueTrend = exports.setRevenueTrend = function setRevenueTrend(payload) {
  return {
    type: "FETCH_REVENUE_TREND",
    payload: payload
  };
};

var setWorkOrderByCategory = exports.setWorkOrderByCategory = function setWorkOrderByCategory(payload) {
  return {
    type: "FETCH_WORKORDER_BY_CATEGORY",
    payload: payload
  };
};
var setPurchaseOrderDetails = exports.setPurchaseOrderDetails = function setPurchaseOrderDetails(payload) {
  return {
    type: "FETCH_PURCHASE_ORDER_DETAILS",
    payload: payload
  };
};

var setWorkOrderByStatus = exports.setWorkOrderByStatus = function setWorkOrderByStatus(payload) {
  return {
    type: "FETCH_WORKORDER_BY_STATUS",
    payload: payload
  };
};

var fetchFinancialYears = exports.fetchFinancialYears = function fetchFinancialYears() {
  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getFinancailYear", "POST", [], {}, [], {}, false, false);

            case 3:
              payload = _context3.sent;


              dispatch(setFinancialYears(payload));
              _context3.next = 10;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);

              console.error(_context3.t0);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, undefined, [[0, 7]]);
    }));

    return function (_x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var fetchExpenditureFundDetails = exports.fetchExpenditureFundDetails = function fetchExpenditureFundDetails() {
  var reqBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getExpenditureFundDetails", "POST", [], reqBody, [], {}, false, false);

            case 3:
              payload = _context4.sent;


              dispatch(setExpenditureFundDetails(payload));
              _context4.next = 10;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);

              console.error(_context4.t0);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, undefined, [[0, 7]]);
    }));

    return function (_x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var fetchSchemeDetailGrant = exports.fetchSchemeDetailGrant = function fetchSchemeDetailGrant() {
  var reqBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return (0, _api.httpRequest)("/v1/grantDashboard/grantSchemeWise", "POST", [], reqBody, [], {}, false, false);

            case 3:
              payload = _context5.sent;


              dispatch(setSchemeDetailGrant(payload));
              _context5.next = 10;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);

              console.error(_context5.t0);

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, undefined, [[0, 7]]);
    }));

    return function (_x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var fetchPurchaseOrderFundDetails = exports.fetchPurchaseOrderFundDetails = function fetchPurchaseOrderFundDetails() {
  var reqBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return (0, _api.httpRequest)("/v1/purchaseorderDashboard/fund", "POST", [], reqBody, [], {}, false, false);

            case 3:
              payload = _context6.sent;


              dispatch(setPurchaseOrderFundDetails(payload));
              _context6.next = 10;
              break;

            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);

              console.error(_context6.t0);

            case 10:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, undefined, [[0, 7]]);
    }));

    return function (_x12) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var fetchWorkOrderFundDetails = exports.fetchWorkOrderFundDetails = function fetchWorkOrderFundDetails() {
  var reqBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return (0, _api.httpRequest)("/v1/workorderDashboard/workorderdataByFund", "POST", [], reqBody, [], {}, false, false);

            case 3:
              payload = _context7.sent;


              dispatch(setWorkOrderFundDetails(payload));
              _context7.next = 10;
              break;

            case 7:
              _context7.prev = 7;
              _context7.t0 = _context7["catch"](0);

              console.error(_context7.t0);

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, undefined, [[0, 7]]);
    }));

    return function (_x14) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var fetchWorkOrderDetails = exports.fetchWorkOrderDetails = function fetchWorkOrderDetails() {
  var reqBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return (0, _api.httpRequest)("/v1/workorderDashboard/workorderdata", "POST", [], reqBody, [], {}, false, false);

            case 3:
              payload = _context8.sent;


              dispatch(setWorkOrderDetails(payload));
              _context8.next = 10;
              break;

            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);

              console.error(_context8.t0);

            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, undefined, [[0, 7]]);
    }));

    return function (_x16) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var fetchDashboardSummaryWithoutFilter = exports.fetchDashboardSummaryWithoutFilter = function fetchDashboardSummaryWithoutFilter() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/summary", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context9.sent;


              dispatch(setDashboardSummaryFilter(payload));
              _context9.next = 10;
              break;

            case 7:
              _context9.prev = 7;
              _context9.t0 = _context9["catch"](0);

              console.error(_context9.t0);

            case 10:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, undefined, [[0, 7]]);
    }));

    return function (_x18) {
      return _ref9.apply(this, arguments);
    };
  }();
};

var fetchFilter = exports.fetchFilter = function fetchFilter() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/dashboardSummaryBasedOnFilter", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context10.sent;


              dispatch(setFilterApi(payload));
              _context10.next = 10;
              break;

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](0);

              console.error(_context10.t0);

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, undefined, [[0, 7]]);
    }));

    return function (_x20) {
      return _ref10.apply(this, arguments);
    };
  }();
};

var fetchContractorDetails = exports.fetchContractorDetails = function fetchContractorDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return (0, _api.httpRequest)("/v1/contractorDashboard/contractorUlbData", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context11.sent;


              dispatch(setContractorDetails(payload));
              _context11.next = 10;
              break;

            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](0);

              console.error(_context11.t0);

            case 10:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, undefined, [[0, 7]]);
    }));

    return function (_x22) {
      return _ref11.apply(this, arguments);
    };
  }();
};

var fetchOpeningBalanceDetails = exports.fetchOpeningBalanceDetails = function fetchOpeningBalanceDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return (0, _api.httpRequest)("/v1/openingBalanceDashboard/openingBalanceUlbData", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context12.sent;


              dispatch(setOpeningBalanceDetails(payload));
              _context12.next = 10;
              break;

            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12["catch"](0);

              console.error(_context12.t0);

            case 10:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, undefined, [[0, 7]]);
    }));

    return function (_x24) {
      return _ref12.apply(this, arguments);
    };
  }();
};

var fetchSupplierDetails = exports.fetchSupplierDetails = function fetchSupplierDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return (0, _api.httpRequest)("/v1/supplierDashboard/supplierUlbData", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context13.sent;


              dispatch(setSupplierDetails(payload));
              _context13.next = 10;
              break;

            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](0);

              console.error(_context13.t0);

            case 10:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, undefined, [[0, 7]]);
    }));

    return function (_x26) {
      return _ref13.apply(this, arguments);
    };
  }();
};

var fetchZoneDetails = exports.fetchZoneDetails = function fetchZoneDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getReceiptsDetailsByZone", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context14.sent;


              dispatch(setZoneDetails(payload));
              _context14.next = 10;
              break;

            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](0);

              console.error(_context14.t0);

            case 10:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, undefined, [[0, 7]]);
    }));

    return function (_x28) {
      return _ref14.apply(this, arguments);
    };
  }();
};

var fetchRevenueTrendDetails = exports.fetchRevenueTrendDetails = function fetchRevenueTrendDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getRevenueDetailsOverview", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context15.sent;


              dispatch(setRevenueTrend(payload));
              _context15.next = 10;
              break;

            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15["catch"](0);

              console.error(_context15.t0);

            case 10:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, undefined, [[0, 7]]);
    }));

    return function (_x30) {
      return _ref15.apply(this, arguments);
    };
  }();
};

var fetchWorkOrderByCategory = exports.fetchWorkOrderByCategory = function fetchWorkOrderByCategory() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getWorkOrderByCategory", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context16.sent;


              dispatch(setWorkOrderByCategory(payload));
              _context16.next = 10;
              break;

            case 7:
              _context16.prev = 7;
              _context16.t0 = _context16["catch"](0);

              console.error(_context16.t0);

            case 10:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, undefined, [[0, 7]]);
    }));

    return function (_x32) {
      return _ref16.apply(this, arguments);
    };
  }();
};

var fetchWorkOrderByStatus = exports.fetchWorkOrderByStatus = function fetchWorkOrderByStatus() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              _context17.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getWorkOrderByStatus", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context17.sent;


              dispatch(setWorkOrderByStatus(payload));
              _context17.next = 10;
              break;

            case 7:
              _context17.prev = 7;
              _context17.t0 = _context17["catch"](0);

              console.error(_context17.t0);

            case 10:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, undefined, [[0, 7]]);
    }));

    return function (_x34) {
      return _ref17.apply(this, arguments);
    };
  }();
};

var fetchTotalGrant = exports.fetchTotalGrant = function fetchTotalGrant() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return (0, _api.httpRequest)("/v1/grantDashboard/grantUlbData", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context18.sent;


              dispatch(setTotalGrant(payload));
              _context18.next = 10;
              break;

            case 7:
              _context18.prev = 7;
              _context18.t0 = _context18["catch"](0);

              console.error(_context18.t0);

            case 10:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, undefined, [[0, 7]]);
    }));

    return function (_x36) {
      return _ref18.apply(this, arguments);
    };
  }();
};

var fetchReceiptsDetails = exports.fetchReceiptsDetails = function fetchReceiptsDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              _context19.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getReceiptDetailsByCards", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context19.sent;


              dispatch(setReceiptsDetails(payload));
              _context19.next = 10;
              break;

            case 7:
              _context19.prev = 7;
              _context19.t0 = _context19["catch"](0);

              console.error(_context19.t0);

            case 10:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, undefined, [[0, 7]]);
    }));

    return function (_x38) {
      return _ref19.apply(this, arguments);
    };
  }();
};

var fetchDepartmentReceiptDetails = exports.fetchDepartmentReceiptDetails = function fetchDepartmentReceiptDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref20 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee20(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getDepartmentReceiptDetails", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context20.sent;


              dispatch(setDepartmentReceiptDetails(payload));
              _context20.next = 10;
              break;

            case 7:
              _context20.prev = 7;
              _context20.t0 = _context20["catch"](0);

              console.error(_context20.t0);

            case 10:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, undefined, [[0, 7]]);
    }));

    return function (_x40) {
      return _ref20.apply(this, arguments);
    };
  }();
};

var fetchPurchaseOrderDetails = exports.fetchPurchaseOrderDetails = function fetchPurchaseOrderDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee21(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;
              _context21.next = 3;
              return (0, _api.httpRequest)("/v1/purchaseorderDashboard/purchaseorderData", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context21.sent;


              dispatch(setPurchaseOrderDetails(payload));
              _context21.next = 10;
              break;

            case 7:
              _context21.prev = 7;
              _context21.t0 = _context21["catch"](0);

              console.error(_context21.t0);

            case 10:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, undefined, [[0, 7]]);
    }));

    return function (_x42) {
      return _ref21.apply(this, arguments);
    };
  }();
};

var fetchExpenditureDetails = exports.fetchExpenditureDetails = function fetchExpenditureDetails() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function () {
    var _ref22 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee22(dispatch) {
      var payload;
      return _regenerator2.default.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return (0, _api.httpRequest)("/v1/financeDashboard/getExpenditureDetailsByCards", "POST", [], filters, [], {}, false, false);

            case 3:
              payload = _context22.sent;


              dispatch(setExpenditureDetails(payload));
              _context22.next = 10;
              break;

            case 7:
              _context22.prev = 7;
              _context22.t0 = _context22["catch"](0);

              console.error(_context22.t0);

            case 10:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, undefined, [[0, 7]]);
    }));

    return function (_x44) {
      return _ref22.apply(this, arguments);
    };
  }();
};

var fetchCurrentLocation = exports.fetchCurrentLocation = function fetchCurrentLocation() {
  return function () {
    var _ref23 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee23(dispatch) {
      var currAddress;
      return _regenerator2.default.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return (0, _commons.getCurrentAddress)();

            case 2:
              currAddress = _context23.sent;

              dispatch(setCurrentLocation(currAddress));

            case 4:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, undefined);
    }));

    return function (_x45) {
      return _ref23.apply(this, arguments);
    };
  }();
};
var fetchActionItems = exports.fetchActionItems = function fetchActionItems(role, ts) {
  return function () {
    var _ref24 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee24(dispatch, getState) {
      var payload, inboxPath, state, app, inbox, _ref25, _ref25$loaded, loaded, _ref25$loading, loading;

      return _regenerator2.default.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              dispatch(fetchActionItemsPending());
              _context24.prev = 1;
              _context24.next = 4;
              return (0, _api.httpRequest)(_endPoints.ACTIONMENU.GET.URL, _endPoints.ACTIONMENU.GET.ACTION, [], role, [], ts);

            case 4:
              payload = _context24.sent;
              inboxPath = process.env.NODE_ENV === "production" ? "/inbox" : "/inbox";

              if (payload && window.location.pathname == inboxPath && payload.actions && Array.isArray(payload.actions) && payload.actions.some && payload.actions.some(function (x) {
                return x.name == "rainmaker-common-workflow";
              })) {
                state = getState();
                app = state.app;
                inbox = app.inbox;
                _ref25 = inbox || {}, _ref25$loaded = _ref25.loaded, loaded = _ref25$loaded === undefined ? false : _ref25$loaded, _ref25$loading = _ref25.loading, loading = _ref25$loading === undefined ? false : _ref25$loading;
                // loaded == false && loading == false && dispatch(fetchInboxRecordsCount());
                // loaded == false && loading == false && dispatch(fetchRecords());
              }

              dispatch(setActionItems(payload.actions));

              _context24.next = 16;
              break;

            case 10:
              _context24.prev = 10;
              _context24.t0 = _context24["catch"](1);

              if (!(!_context24.t0.data || Object.keys(_context24.t0.data).length === 0)) {
                _context24.next = 16;
                break;
              }

              // // console.log("Rediecting to logout due to empty error data");
              // // localStorage.clear();
              // // sessionStorage.clear();
              // // window.location.href = "/";
              // // return;

              //  Object.keys(localStorage).forEach((key) => {
              //   if (key !== "localization_en_IN") {
              //     localStorage.removeItem(key);
              //   }
              // });

              // sessionStorage.clear();
              // window.location.href = "/";
              // return;

              console.log("Session expired, clearing storage in 5 seconds...");
              dispatch(showSnackbar("Session Expired"));

              // setTimeout(() => {
              //   // Clear all except localization_en_IN
              //   Object.keys(localStorage).forEach((key) => {
              //     if (key !== "localization_en_IN") {
              //       localStorage.removeItem(key);
              //       dispatch(showSnackbar(""));
              //     }
              //   });


              //   sessionStorage.clear();

              //   window.location.href = "/";
              // }, 3000);

              return _context24.abrupt("return");

            case 16:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, undefined, [[1, 10]]);
    }));

    return function (_x46, _x47) {
      return _ref24.apply(this, arguments);
    };
  }();
};

var setUiCommonConfig = exports.setUiCommonConfig = function setUiCommonConfig(payload) {
  return {
    type: actionTypes.FETCH_UI_COMMON_CONFIG,
    payload: payload
  };
};

var setUiCommonConstants = exports.setUiCommonConstants = function setUiCommonConstants(payload) {
  return {
    type: actionTypes.FETCH_UI_COMMON_CONSTANTS,
    payload: payload
  };
};

var fetchUiCommonConfig = exports.fetchUiCommonConfig = function fetchUiCommonConfig() {
  _util.debug;
  return function () {
    var _ref26 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee25(dispatch) {
      var requestBody, payload, MdmsRes, commonMasters, UiCommonConfig;
      return _regenerator2.default.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              requestBody = {
                MdmsCriteria: {
                  tenantId: _common2.default.tenantId,
                  moduleDetails: [{
                    moduleName: "common-masters",
                    masterDetails: [{
                      name: "uiCommonConfig"
                    }]
                  }]
                }
              };
              _context25.prev = 1;
              _context25.next = 4;
              return (0, _api.httpRequest)(_endPoints.MDMS.GET.URL, _endPoints.MDMS.GET.ACTION, [], requestBody);

            case 4:
              payload = _context25.sent;
              MdmsRes = payload.MdmsRes;

              console.log("mdmsRes", MdmsRes);
              commonMasters = MdmsRes["common-masters"];
              UiCommonConfig = commonMasters["uiCommonConfig"];

              dispatch(setUiCommonConfig(UiCommonConfig[0]));
              _context25.next = 14;
              break;

            case 12:
              _context25.prev = 12;
              _context25.t0 = _context25["catch"](1);

            case 14:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, undefined, [[1, 12]]);
    }));

    return function (_x48) {
      return _ref26.apply(this, arguments);
    };
  }();
};

var fetchUiCommonConstants = exports.fetchUiCommonConstants = function fetchUiCommonConstants() {
  _util.debug;
  return function () {
    var _ref27 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee26(dispatch) {
      var requestBody, payload, MdmsRes, commonMasters, UiCommonConstants;
      return _regenerator2.default.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              requestBody = {
                MdmsCriteria: {
                  tenantId: _common2.default.tenantId,
                  moduleDetails: [{
                    moduleName: "common-masters",
                    masterDetails: [{
                      name: "uiCommonConstants"
                    }]
                  }]
                }
              };
              _context26.prev = 1;
              _context26.next = 4;
              return (0, _api.httpRequest)(_endPoints.MDMS.GET.URL, _endPoints.MDMS.GET.ACTION, [], requestBody);

            case 4:
              payload = _context26.sent;
              MdmsRes = payload.MdmsRes;
              commonMasters = MdmsRes["common-masters"];
              UiCommonConstants = commonMasters["uiCommonConstants"];

              dispatch(setUiCommonConstants(UiCommonConstants[0]));
              _context26.next = 13;
              break;

            case 11:
              _context26.prev = 11;
              _context26.t0 = _context26["catch"](1);

            case 13:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26, undefined, [[1, 11]]);
    }));

    return function (_x49) {
      return _ref27.apply(this, arguments);
    };
  }();
};

var setNotificationCount = exports.setNotificationCount = function setNotificationCount(count) {
  return {
    type: actionTypes.GET_NOTIFICATION_COUNT,
    count: count
  };
};

var getNotificationCount = exports.getNotificationCount = function getNotificationCount(queryObject, requestBody) {
  return function () {
    var _ref28 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee27(dispatch, getState) {
      var payload;
      return _regenerator2.default.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              _context27.prev = 0;
              _context27.next = 3;
              return (0, _api.httpRequest)(_endPoints.EVENTSCOUNT.GET.URL, _endPoints.EVENTSCOUNT.GET.ACTION, queryObject, requestBody);

            case 3:
              payload = _context27.sent;

              dispatch(setNotificationCount(payload.unreadCount));
              _context27.next = 9;
              break;

            case 7:
              _context27.prev = 7;
              _context27.t0 = _context27["catch"](0);

            case 9:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27, undefined, [[0, 7]]);
    }));

    return function (_x50, _x51) {
      return _ref28.apply(this, arguments);
    };
  }();
};

var setNotificationsComplete = exports.setNotificationsComplete = function setNotificationsComplete(payload) {
  return {
    type: actionTypes.GET_NOTIFICATIONS_COMPLETE,
    payload: payload
  };
};

var setNotificationsPending = function setNotificationsPending() {
  return {
    type: actionTypes.GET_NOTIFICATIONS_PENDING
  };
};

var setNotificationsError = function setNotificationsError() {
  return {
    type: actionTypes.GET_NOTIFICATIONS_ERROR
  };
};

var getNotifications = exports.getNotifications = function getNotifications(queryObject, requestBody) {
  return function () {
    var _ref29 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee28(dispatch, getState) {
      var payload, transformedEvents;
      return _regenerator2.default.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              dispatch(setNotificationsPending());
              _context28.prev = 1;
              _context28.next = 4;
              return (0, _api.httpRequest)(_endPoints.NOTIFICATIONS.GET.URL, _endPoints.NOTIFICATIONS.GET.ACTION, queryObject, requestBody);

            case 4:
              payload = _context28.sent;
              _context28.next = 7;
              return (0, _commons.getTransformedNotifications)(payload.events);

            case 7:
              transformedEvents = _context28.sent;

              dispatch(setNotificationsComplete(transformedEvents));
              _context28.next = 14;
              break;

            case 11:
              _context28.prev = 11;
              _context28.t0 = _context28["catch"](1);

              dispatch(setNotificationsError(_context28.t0.message));

            case 14:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28, undefined, [[1, 11]]);
    }));

    return function (_x52, _x53) {
      return _ref29.apply(this, arguments);
    };
  }();
};

var fetchInboxRecordsCount = exports.fetchInboxRecordsCount = function fetchInboxRecordsCount() {
  return function () {
    var _ref30 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee29(dispatch, getState) {
      var tenantId, requestBody, payload, state, app, inboxRemData, _ref31, _ref31$loaded, remainingDataLoaded;

      return _regenerator2.default.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              _context29.prev = 0;
              tenantId = (0, _localStorageUtils.getTenantId)();
              requestBody = [{ key: "tenantId", value: tenantId }];
              _context29.next = 5;
              return (0, _api.httpRequest)(_endPoints2.INBOXRECORDSCOUNT.GET.URL, _endPoints2.INBOXRECORDSCOUNT.GET.ACTION, requestBody);

            case 5:
              payload = _context29.sent;
              state = getState();
              app = state.app;
              inboxRemData = app.inboxRemData;
              _ref31 = inboxRemData || {}, _ref31$loaded = _ref31.loaded, remainingDataLoaded = _ref31$loaded === undefined ? false : _ref31$loaded;

              remainingDataLoaded == false && payload > 100 && dispatch(fetchRemRecords(payload));
              dispatch(fetchInboxCount(payload));
              _context29.next = 17;
              break;

            case 14:
              _context29.prev = 14;
              _context29.t0 = _context29["catch"](0);

              dispatch(fetchInboxRecordsError(_context29.t0.message));

            case 17:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29, undefined, [[0, 14]]);
    }));

    return function (_x54, _x55) {
      return _ref30.apply(this, arguments);
    };
  }();
};
var fetchRecords = exports.fetchRecords = function fetchRecords() {
  return function () {
    var _ref32 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee30(dispatch, getState) {
      var tenantId, requestBody, escRequestBody, payload, escalatedPayload;
      return _regenerator2.default.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              dispatch(fetchInboxRecordsPending());
              _context30.prev = 1;
              tenantId = (0, _localStorageUtils.getTenantId)();
              requestBody = [{ key: "tenantId", value: tenantId }, { key: "offset", value: 0 }, { key: "limit", value: 100 }];
              escRequestBody = [{ key: "tenantId", value: tenantId }];
              _context30.next = 7;
              return (0, _api.httpRequest)(_endPoints2.INBOXRECORDS.GET.URL, _endPoints2.INBOXRECORDS.GET.ACTION, requestBody);

            case 7:
              payload = _context30.sent;

              if (!(payload.ProcessInstances && payload.ProcessInstances.length > 0 && payload.ProcessInstances.length != 100)) {
                _context30.next = 13;
                break;
              }

              _context30.next = 11;
              return (0, _api.httpRequest)(_endPoints2.INBOXESCALTEDRECORDS.GET.URL, _endPoints2.INBOXESCALTEDRECORDS.GET.ACTION, escRequestBody);

            case 11:
              escalatedPayload = _context30.sent;

              escalatedPayload.ProcessInstances && escalatedPayload.ProcessInstances.length > 0 && escalatedPayload.ProcessInstances.forEach(function (data) {
                data.isEscalatedApplication = true;
                payload.ProcessInstances.push(data);
              });

            case 13:
              dispatch(fetchInboxRecords(payload.ProcessInstances));
              _context30.next = 19;
              break;

            case 16:
              _context30.prev = 16;
              _context30.t0 = _context30["catch"](1);

              dispatch(fetchInboxRecordsError(_context30.t0.message));

            case 19:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30, undefined, [[1, 16]]);
    }));

    return function (_x56, _x57) {
      return _ref32.apply(this, arguments);
    };
  }();
};
var fetchRemRecords = exports.fetchRemRecords = function fetchRemRecords() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    var _ref33 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee31(dispatch, getState) {
      var tenantId, requestBody, escRequestBody, payload, escalatedPayload;
      return _regenerator2.default.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              dispatch(fetchRemInboxRecordsPending());
              _context31.prev = 1;
              tenantId = (0, _localStorageUtils.getTenantId)();

              count = localStorage.getItem("jk-test-inbox-record-count") || count;
              requestBody = [{ key: "tenantId", value: tenantId }, { key: "offset", value: 100 }, { key: "limit", value: count - 100 }];
              escRequestBody = [{ key: "tenantId", value: tenantId }];
              _context31.next = 8;
              return (0, _api.httpRequest)(_endPoints2.INBOXRECORDS.GET.URL, _endPoints2.INBOXRECORDS.GET.ACTION, requestBody);

            case 8:
              payload = _context31.sent;

              if (!(payload.ProcessInstances && payload.ProcessInstances.length > 0)) {
                _context31.next = 14;
                break;
              }

              _context31.next = 12;
              return (0, _api.httpRequest)(_endPoints2.INBOXESCALTEDRECORDS.GET.URL, _endPoints2.INBOXESCALTEDRECORDS.GET.ACTION, escRequestBody);

            case 12:
              escalatedPayload = _context31.sent;

              escalatedPayload.ProcessInstances && escalatedPayload.ProcessInstances.length > 0 && escalatedPayload.ProcessInstances.forEach(function (data) {
                data.isEscalatedApplication = true;
                payload.ProcessInstances.push(data);
              });

            case 14:
              dispatch(fetchRemInboxRecords(payload.ProcessInstances));
              _context31.next = 20;
              break;

            case 17:
              _context31.prev = 17;
              _context31.t0 = _context31["catch"](1);

              dispatch(fetchRemInboxRecordsError(_context31.t0.message));

            case 20:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31, undefined, [[1, 17]]);
    }));

    return function (_x59, _x60) {
      return _ref33.apply(this, arguments);
    };
  }();
};
var resetFetchRecords = exports.resetFetchRecords = function resetFetchRecords() {
  return function () {
    var _ref34 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee32(dispatch, getState) {
      return _regenerator2.default.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              dispatch(fetchResetInboxRecords());

            case 1:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, undefined);
    }));

    return function (_x61, _x62) {
      return _ref34.apply(this, arguments);
    };
  }();
};

var setCitizenConsertFormData = exports.setCitizenConsertFormData = function setCitizenConsertFormData(payload) {
  return {
    type: actionTypes.FETCH_CITIZEN_CONSENT_FORM,
    payload: payload
  };
};

var fetchCitizenConsentForm = exports.fetchCitizenConsentForm = function fetchCitizenConsentForm() {
  return function () {
    var _ref35 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee33(dispatch) {
      var requestBody, payload, MdmsRes, commonMasters, citizenConsertFormData;
      return _regenerator2.default.wrap(function _callee33$(_context33) {
        while (1) {
          switch (_context33.prev = _context33.next) {
            case 0:
              requestBody = {
                MdmsCriteria: {
                  tenantId: _common2.default.tenantId,
                  moduleDetails: [{
                    moduleName: "common-masters",
                    masterDetails: [{
                      name: "CitizenConsentForm"
                    }]
                  }]
                }
              };
              _context33.prev = 1;
              _context33.next = 4;
              return (0, _api.httpRequest)(_endPoints.MDMS.GET.URL, _endPoints.MDMS.GET.ACTION, [], requestBody);

            case 4:
              payload = _context33.sent;
              MdmsRes = payload.MdmsRes;
              commonMasters = MdmsRes["common-masters"];
              citizenConsertFormData = commonMasters["CitizenConsentForm"];

              dispatch(setCitizenConsertFormData(citizenConsertFormData[0]));
              _context33.next = 13;
              break;

            case 11:
              _context33.prev = 11;
              _context33.t0 = _context33["catch"](1);

            case 13:
            case "end":
              return _context33.stop();
          }
        }
      }, _callee33, undefined, [[1, 11]]);
    }));

    return function (_x63) {
      return _ref35.apply(this, arguments);
    };
  }();
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/app/actions.js
// module id = ../lib/egov-ui-kit/redux/app/actions.js
// module chunks = 504